import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';

@Component({
  selector: 'app-what-is-kachiing',
  templateUrl: './what-is-kachiing.component.html',
  styleUrl: './what-is-kachiing.component.scss',
})
export class WhatIsKachiingComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  constructor(
    private sharedService: SharedService,
    private seoService: SeoService
  ) {}

  ngOnInit(): void {
    this.seoService.update({
      title: 'How You Can Earn on Kachiing',
      description: `Our platform is designed not only for convenience and community but also for providing multiple income-generating opportunities. Whether you're passionate about maintaining a safe digital space, helping businesses improve, or sharing your expertise, Kachiing offers diverse ways for you to earn.`,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openShopPopup(tab1, tab2) {
    this.sharedService.triggerInitTabProfile(tab1);
    setTimeout(() => {
      this.sharedService.triggerInitMarketProfile(tab2);
    }, 100);
  }
}
